import React from 'react';
import { SystemStyleObject } from '@/styled-system/types';
import { Icon } from '@zillow/constellation-10';

const StyledLogo = ({
  css,
  children,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  css?: SystemStyleObject;
}) => (
  <Icon
    css={{
      color: '{colors.icon.accent.blue.strong}',
      '& > [data-part="plus"]': {
        color: '{colors.icon.accent.orange.strong}',
      },
      height: '100%',
      width: '100%',
      ...css,
    }}
  >
    <svg {...props}>{children}</svg>
  </Icon>
);

export default function ShowingTimePlusLogo({
  css,
}: {
  css?: SystemStyleObject;
}) {
  return (
    <StyledLogo
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 905.33 155.58"
      fill="currentColor"
      css={css}
    >
      <path d="M22.47,88.93c-1.1,9.14,1.43,17.33,12.88,17.33,9.42,0,15.8-4.97,18.23-13.63,2.55-8.96-.01-14.51-12.06-22.04-18.11-11.03-23.44-20.19-19.06-35.86C27.21,17.22,42.43,4.58,63.97,4.58c27.95,0,31.24,18.79,28.2,32.73h-21.32c.85-6.67,.31-15.5-11.14-15.5-8.4,0-13.46,4.71-15.41,11.82-1.99,7.25,.74,11.16,12.68,18.47,20.22,12.09,24.17,23.02,19.07,39.69-4.99,17.62-20.24,31.69-45.18,31.69C2.79,123.47-2.67,106.37,1.03,88.93H22.47Z" />
      <path d="M137.36,0l-15.48,42.79c5.62-5.99,13.5-10.6,24.39-10.6,14.94,0,21.47,9.64,14.22,29.71l-21.54,59.74h-21.42l20.49-56.8c3.16-8.76,2.89-14.67-6.06-14.67-9.45,0-15.37,7.48-19.9,19.91l-18.63,51.56h-21.68L115.69,0h21.67Z" />
      <path d="M236.13,74.79c-7.3,25.66-24.23,48.4-51.9,48.4-24.17,0-30.6-16.55-22.48-43.19,7.65-25.78,26.16-47.78,51.92-47.78s29.85,18,22.47,42.57Zm-52.75,6.05c-5.2,16.86-3.3,24.86,6.11,24.86,11.2,0,19.9-14.54,25.06-31.35,4.61-15.2,4.44-24.55-6.06-24.55-11.56,0-20.77,15.85-25.11,31.03Z" />
      <path d="M270.84,33.74c-4.94,30.4-9.08,53.5-11.39,63.93h.32c5.21-10.53,14.42-26.21,35.86-63.93h20.02c-4.68,30.09-7.74,53.21-10.18,63.61h.17c4.56-9.51,11.82-22.82,34.25-63.61h21.97l-54.46,87.9h-22.04c4.31-27.23,6.57-45.78,9.04-58h-.17c-6.28,12.55-18.29,32.17-33.6,58h-22.22l10.37-87.9h22.06Z" />
      <path d="M367.96,33.74h21.67l-31.76,87.9h-21.67l31.76-87.9Z" />
      <path d="M389.76,61.12c6.57-18.09,8.36-23.49,9.61-27.38h21.12c-.44,1.89-1.69,6.24-2.95,9.87,5.25-6.03,13.11-11.42,24.45-11.42,15.81,0,21.69,10.4,14.54,29.99l-21.43,59.46h-21.62l20.24-56.1c3.35-9.19,3.11-15.18-5.78-15.18-8.39,0-14.36,4.86-19.5,19.03l-18.87,52.25h-21.68l21.86-60.52Z" />
      <path d="M515.94,113.51c-8.9,24.83-20.93,42.07-50.01,42.07-26.8,0-28.24-16.46-25.24-27.62h20.77c-.92,5.29,.66,10.68,9.68,10.68,12.36,0,17.41-8.44,22.78-23.02l2.03-5.21c-6.24,7.19-14.32,9.98-23.05,9.98-18.37,0-23.78-15.5-16.35-40.25,8.36-27.81,26.34-47.92,47.01-47.92,11.9,0,16.05,5.46,16.69,10.13,1.29-3.2,2.99-6.92,3.85-8.61h21.03c-2.17,5.39-5.47,14.26-9.96,26.55l-19.24,53.21Zm-37.04-34c-5.13,16.11-2.35,23.16,6.46,23.16,10.3,0,16.89-8.44,23.22-25.81,6.23-16.63,7.59-26.82-4.79-26.82-10.6,0-19.51,12.24-24.89,29.47Z" />
      <path d="M565.14,25.07h-26.74l6.78-18.72h87.36l-6.78,18.72h-38.48l-34.88,96.58h-22.14l34.88-96.58Z" />
      <polygon points="371.03 25.07 392.71 25.07 399.47 6.35 377.8 6.35 371.03 25.07" />
      <path d="M600.9,33.74h21.67l-31.76,87.9h-21.67l31.76-87.9Z" />
      <path d="M627.2,60.48c6.26-17.37,8.04-22.65,9.4-26.74h20.85c-.39,1.91-1.86,6.85-2.8,9.55,6.73-7.04,14.41-11.07,24.09-11.07,10.39,0,14.41,5.16,14.85,12.06,5.98-6.33,14.55-12.06,26.58-12.06,13.59,0,22.28,7.45,14.28,29.48l-21.58,59.95h-21.18l21.21-58.59c2.58-7.21,2.27-13-5.43-13-8.79,0-14.17,6.58-18.39,18.32l-19.26,53.27h-21.32l21.1-58.35c2.82-7.86,1.98-13.09-5.34-13.09-8.37,0-13.99,5.76-18.77,19.03l-18.92,52.41h-21.45l22.06-61.17Z" />
      <path d="M755.09,82.99c-.78,1.96-1.54,4.12-1.98,6.19-1.88,8.84-.98,16.7,8.13,16.7s13.01-5.93,15.8-10.53h21.2c-6.41,12.1-18.67,27.8-42.08,27.8-26.96,0-28.07-20.77-21.7-42.94,6.43-22.13,23.4-47.98,51.38-47.98,25.57,0,27.91,19.54,21.39,39.9-.45,2.13-2.6,7.83-3.96,10.86h-48.18Zm32.38-14.85c.74-1.73,1.38-3.41,1.72-5.01,1.52-7.36,.57-14-8.42-14-10.41,0-16.7,10.63-20.11,19.01h26.82Z" />
      <path
        data-part="plus"
        d="M846.71,92.15h-30.56l6.87-18.15h30.56l10.91-28.82h21.19l-10.91,28.82h30.56l-6.87,18.15h-30.56l-10.84,28.63h-21.19l10.84-28.63Z"
      />
    </StyledLogo>
  );
}
